<template>
<v-container>
  <v-row no-gutters v-if="is_required == false">
    <v-col 
          cols="auto"
          class="ml-auto mb-1">
      <v-btn text small @click="skip" :style="{color: this.bot_setting.main_color}">Skip »</v-btn>
    </v-col>
  </v-row>
  <v-row no-gutters justify="center" align="center">
    <v-col class="pr-2">
      <v-textarea
        ref="input_value"
        v-model="input_value"
        :label="placeholder"
        :error-messages="!checkValid ? error_message_2: ''"
        solo
        rows="1"
        :no-resize=true
        :autofocus="true"
      ></v-textarea>
    </v-col>
    <v-col 
          cols="auto"
          class="ml-auto mb-7 mb-4">
      <v-btn dark @click="submit" :style="{backgroundColor: bot_setting.main_color}">Submit</v-btn>
    </v-col>
  </v-row>
</v-container>
</template>

<style>
.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea{
  margin-top: 0px;
}
</style>

<script>
import utils from '@/utils/utils.js'

export default {

  name: "MultilineInput",

  props: ['placeholder', 'error_message', 'pattern_match', 'bot_setting', 'is_required', 'label_name', 'question_id', 'answer_data', 'custom_validation'],

  data: () =>({
    input_value: "", 
    checkValid: true,
    error_message_2: ''
  }),

  created(){
    this.error_message_2 = this.error_message
  },

  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      if (this.validateInput() == true){
        var emitValue = {user_chat_message: this.input_value, user_chat_value:this.input_value}
        this.$emit('text_input_submitted', emitValue)
        this.input_value = ''
      }else{
        this.checkValid = false
        this.$nextTick(()=>this.$refs.input_value.focus())
      }
    },

    customValidation(_input_value){
      if (this.custom_validation.length > 0){
        this.error_message_2 = ''
        var temp_answer_data = JSON.parse(JSON.stringify(this.answer_data))
        temp_answer_data.push({ 'key': this.label_name, 'value': _input_value, 'question_id': this.question_id })

        for(var j=0; j < this.custom_validation.length; j++){
          if (this.custom_validation[j].rule != ''){
            var validation_result = utils.runCustomValidation(this.custom_validation[j].rule, temp_answer_data)
            if (validation_result == false){
              this.error_message_2 = this.custom_validation[j].error_message
              return false
            }
          }
        }
      }
      return true
    },

    validateInput(){
      this.error_message_2 = this.error_message
      this.checkValid = true
      if (this.is_required == true){
        if (this.input_value == null || this.input_value == ""){
          return false
        }
      }
      if (this.pattern_match != null || this.pattern_match != ""){
        var regex = new RegExp(this.pattern_match)
        if (regex.test(this.input_value)){
          if (this.customValidation(this.input_value) == false) {
            this.checkValid = false
            return false
          }else{
            return true
          }
        }else{
          this.checkValid = false
          return false
        }
      }else{
        return true
      }
    }

  }

}
</script>